import React from 'react';

interface CloseIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CloseIcon: React.FC<CloseIconProps> = ({ 
  width = 32, 
  height = 32, 
  color = "black" 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="white" fillOpacity="0.01"/>
      <rect width="20" height="20" transform="translate(6 6)" fill="white" fillOpacity="0.01"/>
      <path 
        d="M21.8334 10.1666L16.0001 16M16.0001 16L10.1667 21.8333M16.0001 16L10.1667 10.1666M16.0001 16L21.8334 21.8333" 
        stroke={color} 
        strokeWidth="1.3" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloseIcon;

